import React from "react";
import "./Dictionary.css";

const Dictionary = ({ word, definition, imageUrl, position }) => {
  return (
    <div
      className="dictionary-popup"
      style={{ top: position.y + 30, left: position.x - 90 }}
    >
      <h4 className="mt-0">{word}</h4>
      {imageUrl && <img src={imageUrl} alt={word} />}
      <p>{definition}</p>
    </div>
  );
};

export default Dictionary;
